import { useEffect, useState } from 'react';

import { useAuth } from './useAuth';

declare global {
  var MentionMe: unknown;
  var MentionMeFiredTags: unknown;
}

export const useMentionMe = () => {
  const { user } = useAuth();
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isAdblockDetected, setIsAdblockDetected] = useState(false);

  useEffect(() => {
    if (!user?.email) {
      return;
    }

    const params = new URLSearchParams({
      email: user.email,
      locale: 'fr_FR',
      situation: 'espaceclientweb',
      ...(user.prenom && { firstname: user.prenom }),
      ...(user.nom && { surname: user.nom }),
    });

    const mentionMeScript = `${import.meta.env.VITE_MENTION_ME_URL}?${params.toString()}`;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = mentionMeScript;
    script.async = true;

    script.onload = () => {
      setIsScriptLoaded(true);
    };

    script.onended = () => {
      const wrapper = document.getElementById('mmWrapper');
      if (wrapper) {
        const hasIframe = wrapper.querySelector('iframe') !== null;
        const hasContent = wrapper.children.length > 0;

        if (!hasIframe && !hasContent) {
          setIsAdblockDetected(true);
        }
      }
    };

    script.onerror = () => {
      setIsAdblockDetected(true);
      setIsScriptLoaded(true);
    };

    document.body.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector(`script[src^="${import.meta.env.VITE_MENTION_ME_URL}"]`);

      if (!isAdblockDetected) {
        // On supprime aussi les variables globales mentionMe et mentionMeFiredTags
        globalThis.MentionMe = undefined;
        globalThis.MentionMeFiredTags = undefined;
      }

      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [user?.email, user?.prenom, user?.nom, isAdblockDetected]);

  return {
    isScriptLoaded,
    isAdblockDetected,
    hasEmail: !!user?.email,
  };
};
